import { Col } from 'react-bootstrap'
import deleteButton from '../../../../_metronic/images/deleteButton.svg'
import { alert } from '../../../../utils/helper'
import { IUtility } from './InterfaceProductSetup'
import { useEffect, useState, Fragment } from 'react'
import { ZipCodeModal } from './ZipCodeModal'
import { State } from 'country-state-city'
type NoteField = "placeholder" | "message";
interface utilityProps {
  id: string
  value: string
  utilityName: string
  utilityDunsNumber: string
  utilitySubmitDays: string
  utilityShortName: string
  utilityPhoneNumber: string
  setUtilityData: any
  regexValidation: string
  regexValidationMessage: string
  utilityState: string
  notesMetadata: any
  uanValidation: any
  errors: any
  readonly: boolean
  setDeletedId: any
  deletedId: any
  utilities: Array<any>
  setErrors: any
  zipcodes: string
  original: any
  meterRegexValidation: any
  meterRegexValidationMessage: any
  featureFlags: any

}

export default function Utility({
  id,
  value,
  utilityName,
  utilityDunsNumber,
  notesMetadata,
  utilitySubmitDays,
  setUtilityData,
  utilityShortName,
  utilityPhoneNumber,
  uanValidation,
  regexValidation,
  regexValidationMessage,
  meterRegexValidation,
  meterRegexValidationMessage,
  utilityState,
  zipcodes,
  errors,
  readonly,
  setDeletedId,
  deletedId,
  utilities,
  setErrors,
  featureFlags,

}: utilityProps) {
  const handleValueChange = (property: any, changedValue: any) => {
    setUtilityData((prev: Array<IUtility>) =>
      prev.map((utility: any) => {
        if (utility.id === id) {
          utility[property] = changedValue
          return utility
        }
        return utility
      })
    )
    setErrors({})
  }
  const validateUtility = (changedValue: any) => {
    if (readonly === undefined && utilities?.includes(changedValue.toLowerCase())) {
      setUtilityData((prev: any) =>
        prev.map((utility: any) => {
          if (utility.id === id) {
            utility['value'] = ''
            return utility
          }
          return utility
        })
      )
      alert('Utility Already Exists', 'warning')
    }
  }


  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [state, setState] = useState<{ id: string; value: string }[]>([])

  const handleAddNote = () => {
    const updated = [...(notesMetadata || []), { placeholder: "", message: "" }];
    handleValueChange("notesMetadata", updated);
  };

  const handleChange = (index: number, field: NoteField, values: string) => {
    const updated = [...(notesMetadata || [])];
    updated[index][field] = values;
    handleValueChange("notesMetadata", updated);
  };

  const handleDeleteNote = (index: number) => {
    const updated = [...(notesMetadata || [])];
    updated.splice(index, 1);
    handleValueChange("notesMetadata", updated);
  };


  useEffect(() => {
    const getAllStates = State.getStatesOfCountry('US')
    setState(getAllStates.map((eachState) => ({ id: eachState.isoCode, value: eachState.name })))
  }, [])

  const handleCloseModal = () => {
    const modalElement = document.getElementById('kt_modal_1')
    if (modalElement) {
      modalElement.style.display = 'block'
    }
    setShowCreateAppModal(false)
  }
  const openModal = (e: any) => {
    const modalElement = document.getElementById('kt_modal_1')
    if (modalElement) {
      modalElement.style.display = 'none'
    }
    e.stopPropagation()
    e.preventDefault()
    setShowCreateAppModal(true)
  }

  return (
    <div className='g-5 mb-7 align-items-center py-7 px-5 custom-box-shadow mt-3 position-relative'>
      <div className='d-flex gap-5 overflow-auto utilityBlock'>

        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold required'>Utility</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            value={value === undefined ? '' : value}
            placeholder='Enter utility'
            readOnly={readonly}
            onChange={(e) => {
              handleValueChange('value', e.target.value)
            }}
            onBlur={() => validateUtility(value)}
          />
          {errors[id]?.utility && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Utility is required
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold required'>
            Utility Pronunciation
            <i
              className='bi bi-info-`circle` ms-2 text-primary cursor-pointer'
              onClick={() => alert('Pronunciation for Utility name in scripts', 'info')}
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            value={Boolean(utilityShortName) ? utilityShortName : ''}
            placeholder='Enter pronunciation'
            maxLength={35}
            onChange={(e) => {
              handleValueChange('utilityShortName', e.target.value)
            }}
            onBlur={() => validateUtility(value)}
          />
          {errors[id]?.shortName && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Pronunciation is required
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold'>
            Utility Name
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert(
                  'Displays full Utility Name during enrollment. Otherwise, name in Utility will be displayed',
                  'info'
                )
              }
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            value={Boolean(utilityName) ? utilityName : ''}
            placeholder='Enter utility name'
            maxLength={35}
            onChange={(e) => {
              handleValueChange('utilityName', e.target.value)
            }}
            onBlur={() => validateUtility(value)}
          />
          {errors[id]?.utilityName && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Utility Name is required
              </div>
            </div>
          )}
        </Col>
        <div className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold required'>Utility DUNS Number</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter DUNS number'
            value={utilityDunsNumber}
            style={{ width: "160px" }}
            onChange={(e) => handleValueChange('utilityDunsNumber', e.target.value)}
          />
          {errors[id]?.dunsNumber && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Utility DUNS number is required
              </div>
            </div>
          )}
        </div>
        <div className='mb-2  mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            Submit Days
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() => alert('Submit Date would be TPV Date + Days added', 'info')}
            ></i>
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className="form-control form-control-lg form-control-solid"
            value={utilitySubmitDays}
            maxLength={3}
            placeholder="Enter Days"
            style={{ width: '130px' }}
            onChange={(e) => {
              const sanitized = e.target.value.replace(/\D/g, '');
              handleValueChange('utilitySubmitDays', sanitized);
            }}
          />
        </div>
        <div className='mb-2  mt-0 pb-6'>
          <label className='mb-2 fw-semibold'>Utility Phone Number
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert(
                  'Add the phone number without a hyphen.',
                  'info'
                )
              }
            ></i>
          </label>
          <div className='d-flex p-relative'>
            <div className='d-flex p-relative'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid d-inline'
                disabled
                maxLength={10}
                style={{
                  width: '24px',
                  padding: '0px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                  fontSize: '14px',
                }}
              />
              <input
                type='number'
                maxLength={10}
                className='form-control form-control-lg form-control-solid p-3 d-inline'
                name='utilityPhoneNumber'
                placeholder='Enter phone number'
                value={Boolean(utilityPhoneNumber) ? utilityPhoneNumber : ''}
                pattern='[0-9]*'
                style={{
                  width: '130px',
                }}
                onChange={(e) =>
                  e.target.value.length < 11 &&
                  handleValueChange('utilityPhoneNumber', e.target.value)
                }
              />
            </div>
          </div>
          {errors[id]?.invalidPhoneNumber && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Invalid Phone number
              </div>
            </div>
          )}
        </div>
        <div className='mb-2 mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            UAN Validation
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert('Helps ensure Utility Account Number has specified number of digits', 'info')
              }
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid d-inline'
            name='utilityPhoneNumber'
            placeholder='Enter UAN digits'
            maxLength={2}
            style={{ width: '130px' }}
            value={Boolean(uanValidation) ? uanValidation : ''}
            onChange={(e) => {
              handleValueChange('uanValidation', e.target.value.replace(/[+\-]/g, ''))
            }}
          />
        </div>
        <div className='mb-2 mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            UAN Regex
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert('Helps ensure Utility Account Number has specified pattern', 'info')
              }
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid d-inline'
            name='utilityregex'
            maxLength={30}
            placeholder='Enter Regex'
            style={{
              width: '200px',
            }}
            value={regexValidation}
            onChange={(e) => {
              handleValueChange('regexValidation', e.target.value)
            }}
          />
        </div>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            UAN Regex Message
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() => alert('Display Utility number format for enrollment', 'info')}
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid d-inline'
            name='utilityRegexMessage'
            placeholder='Enter Regex message'
            value={regexValidationMessage}
            maxLength={60}
            onChange={(e) => {
              handleValueChange('regexValidationMessage', e.target.value)
            }}
          />
        </Col>
        {featureFlags?.getClientFeatureFlags?.isUtilityMeterNumberRequired && (
          <>
            <div className='mb-2 mt-0 pb-6'>
              <label className='fw-semibold mb-2'>
                Meter ID Regex
                <i
                  className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                  onClick={() => alert('Helps ensure Meter Id has specified pattern', 'info')}
                ></i>
              </label>
              <input
                type='string'
                className='form-control form-control-lg form-control-solid d-inline'
                name='meterregex'
                placeholder='Enter Meter ID'
                maxLength={30}
                value={meterRegexValidation}
                style={{
                  width: '200px',
                }}
                onChange={(e) => {
                  handleValueChange('meterRegexValidation', e.target.value)
                }}
              />
            </div>
            <div className='mb-2 mt-0 pb-6'>
              <label className='fw-semibold mb-2'>
                Meter ID Regex Message
                <i
                  className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                  onClick={() => alert('Display Meter ID for enrollment', 'info')}
                ></i>
              </label>
              <input
                type='string'
                className='form-control form-control-lg form-control-solid d-inline'
                name='meterRegexMessage'
                placeholder='Enter Meter ID message'
                maxLength={60}
                style={{
                  width: '200px',
                }}
                value={meterRegexValidationMessage}
                onChange={(e) => {
                  handleValueChange('meterRegexValidationMessage', e.target.value)
                }}
              />
            </div>
          </>
        )}
        {featureFlags?.getClientFeatureFlags?.enableZipCodeInUtility && (
          <div className='mb-2 mt-0 pb-6'>
            <label className='fw-semibold mb-2'>State</label>
            <select
              id='utilityState'
              name='utilityState'
              value={utilityState}
              style={{
                width: '140px',
              }}
              className='basic-single form-select form-select-solid'
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                handleValueChange('utilityState', e.target.value)
              }
            >
              <option value=''>Select a State</option>
              {Array.isArray(state) &&
                state.map((option: { id: string; value: string }) => (
                  <option key={option.id} value={option.value} >
                    {option.value}
                  </option>
                ))}
            </select>
          </div>
        )}

        {featureFlags?.getClientFeatureFlags?.enableZipCodeInUtility && (
          <Col lg={1} className='mb-2 mt-0 pb-6'>
            <label className='fw-semibold mb-2'>
              Zip Code
              <i
                className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                onClick={() =>
                  alert('Helps ensure the area where the utility is available', 'info')
                }
              ></i>
            </label>
            <div className='d-flex flex-stack '>
              <button className='btn btn-light-primary' onClick={openModal}>
                View All
              </button>
            </div>
            <ZipCodeModal
              show={showCreateAppModal}
              handleClose={handleCloseModal}
              zipcodes={zipcodes ? zipcodes : []}
              handleValueChange={handleValueChange}
            />
          </Col>
        )}
        {/* here we increase col lg size based on the notes size */}
        {notesMetadata?.length > 0 &&
          notesMetadata.map((n: any, i: number) => (
            <Fragment key={i}>

              <Col lg={2} className="mb-2 mt-0 pb-6">
                <div className="d-flex align-items-center mb-2">
                  <label className="fw-semibold mb-0">{`Note ${i + 1}`}</label>
                  <i
                    className="bi bi-x-circle text-danger ms-1 cursor-pointer"
                    style={{ fontSize: '14px' }}
                    onClick={() => handleDeleteNote(i)}
                    title="Delete this note"
                  ></i>
                </div>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-solid w-100"
                  name={`note${i + 1}`}
                  placeholder={`Enter Note ${i + 1}`}
                  value={n?.placeholder}
                  maxLength={30}
                  onChange={(e) => handleChange(i, "placeholder", e.target.value)}
                />
              </Col>

              <Col lg={2} className="mb-2 mt-0 pb-6">
                <label className="fw-semibold mb-2 w-100">
                  Note {i + 1} Message
                  <i
                    className="bi bi-info-circle ms-2 text-primary cursor-pointer"
                    onClick={() =>
                      alert(
                        "Required to enter Note value and display message for enrollment",
                        "info"
                      )
                    }
                  ></i>
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-solid w-100"
                  name={`noteMessage${i + 1}`}
                  placeholder={`Enter Note ${i + 1} Message`}
                  value={n?.message}
                  maxLength={60}
                  onChange={(e) => handleChange(i, "message", e.target.value)}
                />
              </Col>
            </Fragment>
          ))}

        {(notesMetadata?.length ?? 0) < 3 && (
          <Col lg={1} className="mb-2 mt-0 pb-6">
            <label className='fw-semibold mb-2'>
              Notes
            </label>
            <div className='d-flex flex-stack '>
              <button
                type="button"
                className="btn btn-light-primary"
                onClick={handleAddNote}
              >
                Add Note
              </button>
            </div>
          </Col>
        )}
      </div>
      <button
        className='btn btn-icon align-self-end ms-4'
        disabled={readonly}
        onClick={(e) => {
          setUtilityData((prev: any) => prev.filter((utility: any) => utility.id !== id))
          if (readonly !== undefined) {
            setDeletedId([...deletedId, id])
          }
        }}
        style={{
          position: 'absolute',
          right: '0',
          top: '-17px',
        }}
      >
        <img src={deleteButton} alt='delete' />
      </button>
    </div>
  )
}
